import { FC, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BookImage from '@assets/images/ai4.png';
import RateIc from '@assets/images/smile-ic-2.png';
import { FaBookmark, FaRegBookmark } from 'react-icons/fa6';
import styles from './index.module.scss';
import cs from 'classnames';
import { IStoryList } from '@coreStory/type';
import { useSaveStory, useUnSaveStory } from '@coreStory/useCase';
import { ButtonCore } from '@components';
import { Dropdown, Flex, Menu } from 'antd';
import { FiMoreVertical } from 'react-icons/fi';

type IUnionColors = 'default' | 'purple' | 'pink' | 'blue';
interface IStoryCard extends IStoryList {
  color?: IUnionColors;
  onEditTitle?: (story: IStoryList) => void;
  onSetVisibility?: (story: IStoryList) => void;
}
const StoryCard: FC<IStoryCard> = (props) => {
  const {
    StoryID,
    StoryImage,
    StoryText,
    StoryName,
    RatePoint,
    IsSaved,
    color = 'default',
  } = props;
  const navigate = useNavigate();
  const cardClassName = cs([styles['story_card'], styles[color]]);
  const { mutate: saveStory } = useSaveStory();
  const { mutate: unSaveStory } = useUnSaveStory();
  const [isStorySaved, setIsStorySaved] = useState<boolean>();

  const menu = (
    <Menu>
      <Menu.Item key="editTitle" onClick={() => props.onEditTitle?.(props)}>
        Edit Title
      </Menu.Item>
      <Menu.Item
        key="visibility"
        onClick={() => props.onSetVisibility?.(props)}>
        visibility
      </Menu.Item>
    </Menu>
  );
  const handleSaveStory = () => {
    StoryID && saveStory(String(StoryID));
    setIsStorySaved(true);
  };
  const handleUnSaveStory = () => {
    StoryID && unSaveStory(String(StoryID));
    setIsStorySaved(false);
  };
  useEffect(() => {
    if (IsSaved) {
      setIsStorySaved(true);
    } else {
      setIsStorySaved(false);
    }
  }, [IsSaved]);

  return (
    <div className={cardClassName}>
      <div>
        <Link to={`/story/${StoryID}`} className={styles['story_img']}>
          {StoryImage ? (
            <img src={`http://${StoryImage}`} alt="Story Image" />
          ) : (
            <img src={BookImage} alt="Default Image" />
          )}
        </Link>
        <div className={styles['edit_menu']}>
          <Dropdown overlay={menu} trigger={['click']}>
            <FiMoreVertical size={16} />
          </Dropdown>
        </div>

        <div className={styles['title']}>
          <h2>{StoryName}</h2>
        </div>
        <div className={styles['story_text']}>
          <p>{StoryText}</p>
        </div>
        <div className={styles['footer']}>
          <div className={styles['story_rate']}>
            <img src={RateIc} />{' '}
            <span className={styles['rate']}>({RatePoint ?? 0}/5)</span>
          </div>

          <div className={styles.actions}>
            <span className={styles['icon']}>
              {isStorySaved ? (
                <FaBookmark size={16} onClick={handleUnSaveStory} />
              ) : (
                <FaRegBookmark size={16} onClick={handleSaveStory} />
              )}
            </span>
            <button onClick={() => navigate(`/story/${StoryID}`)}>View</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryCard;
